import Model from '../BaseModel'
import i18n from '@/plugins/i18n'

export default class Configuration extends Model {
    resourceName() {
        return 'commission/configurations'
    }

    fields() {
        return [
            'licenses',
            'periods',
            'commission_cycle',
            'fixed_category_payment_limit',
        ]
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('commissions.configurations.index.table.licenses'),
                value: 'licenses',
                sortable: false,
            },
            {
                text: i18n.t('commissions.configurations.index.table.periods'),
                value: 'periods',
                sortable: false,
            },
            {
                text: i18n.t(
                    'commissions.configurations.index.table.commission_cycle',
                ),
                value: 'commission_cycle',
                sortable: false,
            },
            {
                text: i18n.t(
                    'commissions.configurations.index.table.fixed_category_payment_limit',
                ),
                value: 'fixed_category_payment_limit',
                sortable: false,
            },
            {
                text: i18n.t('tables.actions'),
                value: 'action',
                sortable: false,
                align: 'end',
            },
        ]
    }
}
